import React, { useState, useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { PROCEDURE_STEPS } from 'containers/data-structure';
import { useSelector } from 'react-redux';
import { get, isEmpty, isNil } from 'lodash';
import { toast } from 'react-toastify';
import moment from 'moment-timezone';
import { isAllValuesIsNil } from 'helpers/utils';
import { EMPTY_INVOICE_INFO } from 'containers/data-structure';
import { Container } from 'containers/LawyerLegalProceedingsPage/judgementAdd/styled-components';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { DATE_FORMAT } from 'constants/global';
import { PAGES } from 'routes';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { Vehicule } from 'containers/PreOpeningPage/typings.d';
import { Listings } from 'containers/AppContainer/typings';
import { CivilParty as ICivilParty } from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';
import { Idetails } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/typings';
import { translate } from 'containers/services/translate';
import * as utils from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import InvoiceInfoDialog from 'components/InvoiceFeeNoteDialog/InvoiceInfoDialog';
import CivilParty from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty';
import ProcedureInformation from 'containers/LawyerLegalProceedingsPage/judgementAdd/ProcedureInformation';
import JudgementAddPronouncing from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing';
import SuccessDialog from 'components/SuccessDialog';
import { pushTo } from 'containers/services/routes-helper';
import JudgementValidationButtons from 'containers/common/LegalProceedings/JudgementValidationButtons';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { getVictimsIncome } from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { isUserActive } from 'containers/common/LegalProceedings/utils';
import FirmReferenceForm from 'components/FirmReferenceForm';
import {
  formatCourtFileNumber,
  validationCourtFileNumber,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { resolveJudiciaryProcessType } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import {
  formatIntervenants,
  extractIntervenant,
} from 'containers/RecapPage/utils';
import InvoiceFeeNoteDialog from 'components/InvoiceFeeNoteDialog';
import DynamiqDialog from 'components/InvoiceFeeNoteDialog/DynamiqDialog';
import currentUserStorage from 'containers/services/security/current-user-storage';
import InvoiceFeeNotesManagerDialog from 'components/InvoiceFeeNoteDialog/InvoiceFeeNotesManagerDialog';
import { formatInvoiceFeeNoteInfos } from 'containers/LawyerLegalProceedingsPage/utils';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import IncomeCertificate from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate';
import IncomeCertificatesRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/IncomeCertificatesRecap';
import { hasIncomeCertificate } from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/utils';
import { isBlockStatusClaim } from 'containers/CourtManagerLegalProceedings/utils';
import { VictimType } from 'typings/globalTypes';
import {
  getLimitInvoiceIntervenant,
  getLimitInvoiceManager,
} from 'services/utils';
import { Typography } from '@material-ui/core';

export interface FormsADDProps {
  intl: IntlShape;
  victims: VictimType[];
  listings: Listings;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  vehicules: Vehicule[];
  resetUploadedDocument: Function;
  requestCreateJudgementAdd: Function;
  claimId: number;
  claimNumber: string;
  details: Idetails;
  judgementAddDocuments: JudgementADDDocumentType[];
  civilPartyDocuments: ICivilParty[];
  setDetails: Function;
  setJudgementAddDocuments: Function;
  setCivilPartyDocuments: Function;
  canStartCivilParty: boolean;
  canStartJudgementAdd: boolean;
  policyInfo: { sagis: {} };
  judiciaryProcessId: number;
  isCivilProceeding: boolean;
  processInformationValidation?: any;
  messageError?: any;
  lossDate: string;
  canValidateJudgementAddProcedure: boolean;
  currentJudiciaryProcess: any;
  setDialogOpenFirmReference?: Function;
  isManager: boolean;
  sagisVictimInfo: Function;
  sagisOpposingParties: any;
  setIsButtonRedirect?: Function;
  feeNotes: any;
  setDocumentId: Function;
  documentId: any;
  requestCreateIncomeCertificate: Function;
  requestUpdateIncomeCertificate: Function;
  requestMakeDecisionIncomeCertificate: Function;
  isConsultation: boolean;
  riskKey: string;
  imagineDocuments: any;
  dahirAmount: [];
  requestGetDocByDocumentumId: Function;
}

export const FormsADD: React.FC<FormsADDProps> = (props): JSX.Element => {
  const [isSuccessPopinOpen, setIsSuccessPopinOpen] = React.useState<boolean>(
    false,
  );
  const [invoiceFeeNoteInfos, setInvoiceFeeNoteInfo] = React.useState<any>([]);
  const [generateFeeNoteLawyer, setGenerateFeeNoteLawyer] = React.useState<
    boolean
  >(false);
  const [openInvoiceInfoLawyers, setOpenInvoiceInfoLawyers] = React.useState<
    boolean
  >(false);
  const [invoiceDocument, setInvoiceDocument] = React.useState({});
  const [invoiceNumber, setInvoiceNumber] = React.useState(null);
  const [invoiceDate, setInvoiceDate] = React.useState(null);
  const [lawyerFirmRef, setLawyerFirmRef] = React.useState(null);
  const [
    decisionGenerationFeeNote,
    setDecisionGenerationFeeNote,
  ] = React.useState(null);
  const [
    openInvoiceFeeNoteInfoDialog,
    setOpenInvoiceFeeNoteInfoDialog,
  ] = React.useState(false);
  const lawyerInfo = {
    code:
      currentIntervenantStorage.get() &&
      currentIntervenantStorage.get().sagis_code,
    name:
      currentIntervenantStorage.get() && currentIntervenantStorage.get().name,
  };
  const [showValidationButton, setShowValidationButton] = useState(true);

  const claimAssignment = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'assignment'], []),
  );
  const claim = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap'], []),
  );
  const assignedLawyersByJudiciaryProcess = claimAssignment.filter(
    (el: any) =>
      el.judiciaryProcessId === props.judiciaryProcessId &&
      el.isDeleted === false,
  );

  const lawyerAssignment = claimAssignment.find(
    (el: any) =>
      el.assignedLawyer === currentIntervenantStorage.get()?.sagis_code &&
      el.judiciaryProcessId === props.judiciaryProcessId &&
      el.isDeleted === false,
  );

  const lawyerFirmReference = get(lawyerAssignment, 'firmReference', null);

  const doNotGenerateFeeNote = () => {
    createJudgementAdd(false);
  };

  const onValidate = () => {
    if (isEmpty(props.judgementAddDocuments)) {
      setShowValidationButton(false);
      return createJudgementAdd(false);
    } else {
      !props.isManager
        ? setIsSuccessPopinOpen(true)
        : isEmpty(
            extractIntervenant(
              get(props.listings, 'intervenants'),
              assignedLawyersByJudiciaryProcess,
            ),
          )
        ? createJudgementAdd(true)
        : setGenerateFeeNoteLawyer(true);
    }
  };

  const successCallback = (withFeeNote: boolean) => () => {
    if (isEmpty(props.judgementAddDocuments)) {
      setShowValidationButton(false);
      return featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE)
        ? !props.isManager && pushTo(PAGES.LAWYER_ASSIGNMENTS)()
        : setIsSuccessPopinOpen(true);
    }
    toast.success(translate(messages.successToastTitle, props));
    if (!featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE)) {
      withFeeNote && !props.isManager
        ? pushTo(PAGES.FEE_NOTE)()
        : isCourtMonitoringManager
        ? pushTo(PAGES.COURT_MANAGER_HOME)()
        : !props.isManager && !withFeeNote
        ? pushTo(PAGES.LAWYER_ASSIGNMENTS)()
        : pushTo(PAGES.MANAGER_FEE_NOTE)();
    } else {
      withFeeNote && !props.isManager
        ? pushTo(PAGES.FEE_NOTE)()
        : !props.isManager &&
          !withFeeNote &&
          pushTo(PAGES.LAWYER_ASSIGNMENTS)();
    }
  };
  useEffect(() => {
    if (props.isManager && !isEmpty(assignedLawyersByJudiciaryProcess)) {
      if (
        !isEmpty(
          extractIntervenant(
            get(props.listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ),
        )
      ) {
        setInvoiceFeeNoteInfo(
          extractIntervenant(
            get(props.listings, 'intervenants'),
            assignedLawyersByJudiciaryProcess,
          ).map((item: any, index: any) => ({
            codeIntervenant: item.ItemKey,
            createdBy:
              currentUserStorage?.get() && currentUserStorage?.get().username,
            ...EMPTY_INVOICE_INFO,
          })),
        );
      }
    }
  }, [
    props.judiciaryProcessId,
    props.currentJudiciaryProcess,
    !claimAssignment,
  ]);

  const handleError = () => {
    setShowValidationButton(true);
    props.setIsButtonRedirect && props.setIsButtonRedirect(false);
  };
  const isCourtMonitoringManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISCOURTMONITORINGMANAGER,
  );
  const createJudgementAdd = (withFeeNote: boolean) => {
    props.isManager &&
      props.setIsButtonRedirect &&
      props.setIsButtonRedirect(true);
    const judgementAdd = utils.judgementAddFormator(
      props.claimId,
      details,
      judgementAddDocuments,
      civilPartyDocuments,
      props.listings,
      props.policyInfo,
      props.isManager,
    );
    props.requestCreateJudgementAdd(
      props.judiciaryProcessId === 0
        ? {
            isLawyer: !props.isManager,
            judgementAdd: {
              ...(!props.isManager
                ? {
                    lawyerCode:
                      currentIntervenantStorage.get() &&
                      currentIntervenantStorage.get().sagis_code,
                  }
                : undefined),
              isManager:
                isCourtMonitoringManager &&
                !userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER),
              ...judgementAdd,
              isInboxesActive: featureService.hasFeature(
                FEATURES.ATTRIBUTION_INBOXES_MANAGER,
              ),
              isTrackingActive: featureService.hasFeature(
                FEATURES.TRACKING_ACTIONS_USER,
              ),
              decisionGenerationFeeNote: decisionGenerationFeeNote,
              claimNumber: props.claimNumber,
              procedureType: PROCEDURE_TYPES.FIRST_INSTANCE,
              jurisdictionDegreeId: 1,
              procedureNatureId: 3,
              isCivilProceeding: props.isCivilProceeding,
              isCompanyIntervenants: formatIntervenants(
                assignedLawyersByJudiciaryProcess,
              ),
              invoiceFeeNoteInfos:
                withFeeNote &&
                props.isManager &&
                !isEmpty(invoiceFeeNoteInfos) &&
                featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE)
                  ? formatInvoiceFeeNoteInfos(invoiceFeeNoteInfos)
                  : [],
              feeNote: withFeeNote
                ? {
                    step: PROCEDURE_STEPS.JUDGEMENT_ADD,
                    codeIntervenant: lawyerInfo.code,
                    courtNumber: `${resolveJudiciaryProcessType(
                      get(props.currentJudiciaryProcess, 'procedureNatureId'),
                    )} ${formatCourtFileNumber(get(details, 'courtFile'))}`,
                    invoiceFeeNote:
                      featureService.hasFeature(
                        FEATURES.BILLING_INFO_FEE_NOTE,
                      ) &&
                      !isAllValuesIsNil({
                        invoiceNumber: invoiceNumber,
                        invoiceDate: invoiceDate,
                        ...invoiceDocument,
                      })
                        ? {
                            codeIntervenant: lawyerInfo.code,
                            createdBy:
                              currentIntervenantStorage?.get() &&
                              currentIntervenantStorage?.get()
                                ?.preferred_username,
                            invoiceNumber: invoiceNumber,
                            invoiceDate:
                              invoiceDate === 'Invalid date'
                                ? null
                                : invoiceDate,
                            receptionDate: moment().format('YYYY-MM-DD'),
                            ...invoiceDocument,
                            isIndexed: false,
                          }
                        : undefined,
                  }
                : undefined,
            },
            isLawyerInboxesActive: featureService.hasFeature(
              FEATURES.LAWYER_INBOXES,
            ),
          }
        : {
            isLawyer: !props.isManager,
            judgementAdd: {
              isManager:
                isCourtMonitoringManager &&
                !userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER),
              isLawyer: !props.isManager,
              ...judgementAdd,
              isInboxesActive: featureService.hasFeature(
                FEATURES.ATTRIBUTION_INBOXES_MANAGER,
              ),
              isTrackingActive: featureService.hasFeature(
                FEATURES.TRACKING_ACTIONS_USER,
              ),
              claimNumber: props.claimNumber,
              ...(!props.isManager
                ? {
                    lawyerCode:
                      currentIntervenantStorage.get() &&
                      currentIntervenantStorage.get().sagis_code,
                  }
                : undefined),
              procedureType: PROCEDURE_TYPES.FIRST_INSTANCE,
              judiciaryProcessId: props.judiciaryProcessId,
              isCivilProceeding: props.isCivilProceeding,
              isCompanyIntervenants: formatIntervenants(
                assignedLawyersByJudiciaryProcess,
              ),
              invoiceFeeNoteInfos:
                withFeeNote &&
                props.isManager &&
                !isEmpty(invoiceFeeNoteInfos) &&
                featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE)
                  ? formatInvoiceFeeNoteInfos(invoiceFeeNoteInfos)
                  : [],
              lawyerFirmReference: lawyerFirmRef,
              assignementId: get(lawyerAssignment, 'id'),
              decisionGenerationFeeNote: decisionGenerationFeeNote,
              feeNote: withFeeNote
                ? {
                    step: PROCEDURE_STEPS.JUDGEMENT_ADD,
                    ...(!props.isManager
                      ? { codeIntervenant: lawyerInfo.code }
                      : undefined),
                    judgementDate: get(
                      judgementAddDocuments,
                      '[0].judgementDate',
                      '',
                    ),
                    judiciaryProcessId: props.judiciaryProcessId,
                    firmReference: isNil(lawyerFirmReference)
                      ? lawyerFirmRef
                      : lawyerFirmReference,
                    courtNumber: `${resolveJudiciaryProcessType(
                      get(props.currentJudiciaryProcess, 'procedureNatureId'),
                    )} ${formatCourtFileNumber(get(details, 'courtFile'))}`,
                    invoiceFeeNote:
                      featureService.hasFeature(
                        FEATURES.BILLING_INFO_FEE_NOTE,
                      ) &&
                      !isAllValuesIsNil({
                        invoiceNumber: invoiceNumber,
                        invoiceDate: invoiceDate,
                        ...invoiceDocument,
                      })
                        ? {
                            codeIntervenant: lawyerInfo.code,
                            createdBy:
                              currentIntervenantStorage?.get() &&
                              currentIntervenantStorage?.get()
                                ?.preferred_username,
                            invoiceNumber: invoiceNumber,
                            invoiceDate:
                              invoiceDate === 'Invalid date'
                                ? null
                                : invoiceDate,
                            receptionDate: moment().format('YYYY-MM-DD'),
                            ...invoiceDocument,
                            isIndexed: false,
                          }
                        : undefined,
                  }
                : undefined,
            },
            isLawyerInboxesActive: featureService.hasFeature(
              FEATURES.LAWYER_INBOXES,
            ),
          },
      successCallback(withFeeNote),
      handleError,
    );
  };

  const handleClick = () => {
    !isEmpty(props.judgementAddDocuments)
      ? createJudgementAdd(true)
      : currentIntervenantStorage.get() && pushTo(PAGES.LAWYER_ASSIGNMENTS)();
  };

  const handleOpenInvoicesInfoDialog = () => {
    setIsSuccessPopinOpen(false);
    setOpenInvoiceFeeNoteInfoDialog(true);
  };

  const handleOpenInvoicesInfoLawyersDialog = () => {
    setGenerateFeeNoteLawyer(false);
    setOpenInvoiceInfoLawyers(true);
  };

  const handleCloseInvoiceFeeNote = () => {
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleValidateInvoice = () => {
    handleClick();
    setOpenInvoiceFeeNoteInfoDialog(false);
  };

  const handleCloseSuccessDialog = () => {
    setIsSuccessPopinOpen(false);
    doNotGenerateFeeNote();
  };

  const handleCloseGenerateFeeNoteLawyer = () => {
    setInvoiceFeeNoteInfo([]);
    setGenerateFeeNoteLawyer(false);
    doNotGenerateFeeNote();
  };
  const {
    details,
    judgementAddDocuments,
    civilPartyDocuments,
    listings,
    victims,
    vehicules,
    uploadDocument,
    uploadedDocument,
    resetUploadedDocument,
    setDetails,
    setJudgementAddDocuments,
    setCivilPartyDocuments,
    processInformationValidation,
    messageError,
    lossDate,
  } = props;

  const currentlawyerAssignment =
    claimAssignment.find(
      (el: any) =>
        el.judiciaryProcessId === props.judiciaryProcessId &&
        el.isDeleted === false,
    ) || {};
  return (
    <Container id="add-bloc">
      {props.isManager && (
        <div style={{ fontWeight: 'bold', fontSize: '18px', color: 'red' }}>
          {!isUserActive(
            props.listings,
            get(currentlawyerAssignment, 'assignedLawyer'),
          ) &&
          !isEmpty(currentlawyerAssignment) &&
          !isEmpty(props.listings)
            ? translate(messages.userNotValidWarning, props, {
                lawyerName: getValueByCode(
                  get(currentlawyerAssignment, 'assignedLawyer', ''),
                  get(props.listings, 'inactiveIntervenants', []),
                ),
              })
            : ''}
        </div>
      )}
      {!isCourtMonitoringManager &&
        lawyerAssignment &&
        !isBlockStatusClaim(props.policyInfo) &&
        !props.isManager && (
          <FirmReferenceForm
            firmReference={lawyerFirmReference}
            message={
              lawyerFirmReference === null
                ? translate(messages.lawyerFirmReferenceUpdateMessage, props)
                : translate(messages.lawyerFirmReferenceEditMessage, props)
            }
            formInputLabel={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            formInputName={translate(
              messages.lawyerFirmReferenceDialogLabel,
              props,
            )}
            validationButtonTitle={
              lawyerFirmReference === null
                ? translate(messages.saveButton, props)
                : translate(messages.editButton, props)
            }
            setIsDialogOpenFirmReference={props.setDialogOpenFirmReference}
            isFeeNoteGenerated={false}
            isForm
            judiciaryProcessId={props.judiciaryProcessId}
            assignment={lawyerAssignment}
            lawyerFirmReference={lawyerFirmReference}
          />
        )}
      <ProcedureInformation
        listings={listings}
        details={details}
        vehicules={vehicules}
        setDetails={setDetails}
        processInformationValidation={processInformationValidation}
        messageError={messageError}
        lossDate={lossDate}
        sagisOpposingParties={props.sagisOpposingParties}
        currentJudiciaryProcess={props.currentJudiciaryProcess}
      />
      {!props.isCivilProceeding && (
        <CivilParty
          victims={victims}
          uploadDocument={uploadDocument}
          uploadedDocument={uploadedDocument}
          civilPartyDocuments={civilPartyDocuments}
          setCivilPartyDocuments={setCivilPartyDocuments}
          resetUploadedDocument={resetUploadedDocument}
          canStartCivilParty={props.canStartCivilParty}
          sagisVictimInfo={props.sagisVictimInfo}
          imagineDocuments={props.imagineDocuments}
          policyInfo={props.policyInfo}
          listings={props.listings}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}
      {!isCourtMonitoringManager && (
        <JudgementAddPronouncing
          judgementAddDocuments={judgementAddDocuments}
          setJudgementAddDocuments={setJudgementAddDocuments}
          listings={listings}
          victims={victims}
          details={details}
          vehicules={vehicules}
          uploadDocument={uploadDocument}
          uploadedDocument={uploadedDocument}
          resetUploadedDocument={resetUploadedDocument}
          disabled={
            !props.isCivilProceeding
              ? !props.canStartJudgementAdd
              : props.canStartJudgementAdd
          }
          judiciaryProcessId={props.judiciaryProcessId}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
          claimAssignment={claimAssignment}
          feeNotes={props.feeNotes}
          imagineDocuments={props.imagineDocuments}
          policyInfo={props.policyInfo}
          claimId={props.claimId}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}
      {showValidationButton && (
        <JudgementValidationButtons
          onValidation={onValidate}
          onCancel={pushTo(PAGES.LAWYER_ASSIGNMENTS)}
          isValidationDisabled={
            isCourtMonitoringManager
              ? featureService.hasFeature(FEATURES.GSJ_OPTIONAL_DATA)
                ? !validationCourtFileNumber(details.courtFile)
                : !props.canValidateJudgementAddProcedure ||
                  !validationCourtFileNumber(details.courtFile) ||
                  (get(details, 'hearingDate') &&
                    moment(get(details, 'hearingDate')).format(DATE_FORMAT) ===
                      'Invalid date')
              : !props.canValidateJudgementAddProcedure ||
                !validationCourtFileNumber(details.courtFile) ||
                (get(details, 'hearingDate') &&
                  moment(get(details, 'hearingDate')).format(DATE_FORMAT) ===
                    'Invalid date')
          }
        />
      )}
      {!props.isConsultation &&
      !isCourtMonitoringManager &&
      featureService.hasFeature(FEATURES.INCOME_CERTIFICATE) &&
      ((lawyerAssignment && !props.isManager) || props.isManager) &&
      props.isCivilProceeding &&
      !isEmpty(props.currentJudiciaryProcess) &&
      !hasIncomeCertificate(
        getVictimsIncome(
          props.isCivilProceeding,
          props.currentJudiciaryProcess,
          { civilDocuments: civilPartyDocuments } as any,
          props.victims,
          claim,
        ),
      ) ? (
        <IncomeCertificate
          victims={getVictimsIncome(
            props.isCivilProceeding,
            props.currentJudiciaryProcess,
            { civilDocuments: civilPartyDocuments } as any,
            props.victims,
            claim,
          )}
          uploadDocument={uploadDocument}
          uploadedDocument={uploadedDocument}
          resetUploadedDocument={resetUploadedDocument}
          sagisVictimInfo={props.sagisVictimInfo}
          requestCreateIncomeCertificate={props.requestCreateIncomeCertificate}
          isManager={userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          claimId={props.claimId}
          claimNumber={props.claimNumber}
          judiciaryProcessId={props.judiciaryProcessId}
          dahirAmount={props.dahirAmount}
          riskKey={props.riskKey}
          claim={claim}
          listings={props.listings}
        />
      ) : hasIncomeCertificate(
          getVictimsIncome(
            props.isCivilProceeding,
            props.currentJudiciaryProcess,
            { civilDocuments: civilPartyDocuments } as any,
            props.victims,
            claim,
          ),
        ) ? (
        <IncomeCertificatesRecap
          victims={getVictimsIncome(
            props.isCivilProceeding,
            props.currentJudiciaryProcess,
            { civilDocuments: civilPartyDocuments } as any,
            props.victims,
            claim,
          )}
          sagisVictimInfo={props.sagisVictimInfo}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocument={props.resetUploadedDocument}
          requestCreateIncomeCertificate={props.requestCreateIncomeCertificate}
          requestUpdateIncomeCertificate={props.requestUpdateIncomeCertificate}
          isManager={userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          claimNumber={props.claimNumber}
          claimId={props.claimId}
          judiciaryProcessId={props.judiciaryProcessId}
          readOnly={false}
          requestMakeDecisionIncomeCertificate={
            props.requestMakeDecisionIncomeCertificate
          }
          isConsultation={props.isConsultation}
          riskKey={props.riskKey}
          claim={claim}
          judgementAdd={{}}
          dahirAmount={props.dahirAmount}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          listings={props.listings}
        />
      ) : (
        <></>
      )}

      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
      !props.isManager ? (
        <InvoiceFeeNoteDialog
          open={isSuccessPopinOpen}
          onClose={() => setIsSuccessPopinOpen(false)}
          decisionGenerationFeeNote={decisionGenerationFeeNote}
          setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
          handleValidate={
            decisionGenerationFeeNote
              ? handleOpenInvoicesInfoDialog
              : handleCloseSuccessDialog
          }
          shouldDisplayFirmReferenceField={
            isEmpty(lawyerFirmReference) && !props.isManager
          }
          setLawyerFirmRef={setLawyerFirmRef}
          lawyerFirmRef={lawyerFirmRef}
        />
      ) : (
        <SuccessDialog
          title={translate(messages.successDialogTitle, props)}
          secondaryButtonTitle={translate(
            messages.successDialogSecondaryButtonTitle,
            props,
          )}
          primaryButtonTitle={
            featureService.hasFeature(FEATURES.FEE_NOTE) &&
            !isEmpty(props.judgementAddDocuments)
              ? translate(messages.successDialogPrimaryButtonTitleJdd, props)
              : translate(messages.successDialogPrimaryButtonTitle, props)
          }
          tertiaryButtonTitle={
            !isEmpty(props.judgementAddDocuments)
              ? translate({ ...messages.doNotGenerateFeeNote }, props)
              : ''
          }
          showIcon={!isEmpty(props.judgementAddDocuments)}
          onTertiaryClick={doNotGenerateFeeNote}
          open={isSuccessPopinOpen}
          onClose={() =>
            !isEmpty(judgementAddDocuments)
              ? setIsSuccessPopinOpen(false)
              : setIsSuccessPopinOpen(true)
          }
          homePath={PAGES.LAWYER_HOME}
          onPrimaryClick={handleClick}
          isExpertReport={false}
          isPrimaryButtonDisabled={
            isEmpty(lawyerFirmReference) && !isCourtMonitoringManager
          }
        />
      )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
        <InvoiceInfoDialog
          open={openInvoiceFeeNoteInfoDialog}
          onClose={handleCloseInvoiceFeeNote}
          handleValidate={handleValidateInvoice}
          invoiceNumber={invoiceNumber}
          invoiceDate={invoiceDate}
          setInvoiceNumber={setInvoiceNumber}
          setInvoiceDate={setInvoiceDate}
          resetUploadedDocument={resetUploadedDocument}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          invoiceDocument={invoiceDocument}
          setInvoiceDocument={setInvoiceDocument}
          limitInvoiceDate={getLimitInvoiceIntervenant(
            get(props.listings, 'appConfig', []),
          )}
        />
      )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
        props.isManager && (
          <InvoiceFeeNoteDialog
            open={generateFeeNoteLawyer}
            onClose={() => setGenerateFeeNoteLawyer(false)}
            decisionGenerationFeeNote={decisionGenerationFeeNote}
            setDecisionGenerationFeeNote={setDecisionGenerationFeeNote}
            handleValidate={
              decisionGenerationFeeNote
                ? handleOpenInvoicesInfoLawyersDialog
                : handleCloseGenerateFeeNoteLawyer
            }
            shouldDisplayFirmReferenceField={
              isEmpty(lawyerFirmReference) && !props.isManager
            }
            setLawyerFirmRef={setLawyerFirmRef}
            lawyerFirmRef={lawyerFirmRef}
          />
        )}
      {featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) && (
        <DynamiqDialog
          open={openInvoiceInfoLawyers}
          onClose={() => setOpenInvoiceInfoLawyers(false)}
          handleValidate={() => {
            createJudgementAdd(true);
            setOpenInvoiceInfoLawyers(false);
          }}
          children={
            <>
              {extractIntervenant(
                get(props.listings, 'intervenants', []),
                assignedLawyersByJudiciaryProcess,
              )?.map((item: any, index: any) => (
                <div style={{ marginTop: 10 }}>
                  <Typography style={{ fontWeight: 700 }}>
                    {translate(messages.intervenantName, props, {
                      IntervenantName: get(item, 'ItemDescription', null),
                    })}
                  </Typography>
                  <InvoiceFeeNotesManagerDialog
                    invoiceFeeNoteInfo={invoiceFeeNoteInfos[index]}
                    listings={listings}
                    invoiceFeeNoteInfos={invoiceFeeNoteInfos}
                    resetUploadedDocument={resetUploadedDocument}
                    uploadedDocument={uploadedDocument}
                    uploadDocument={uploadDocument}
                    assignedLawyersByJudiciaryProcess={
                      assignedLawyersByJudiciaryProcess
                    }
                    setDocumentId={props.setDocumentId}
                    setInvoiceFeeNoteInfo={setInvoiceFeeNoteInfo}
                    documentId={props.documentId}
                    index={index}
                    displayFirmReferenceInput={
                      isNil(get(item, 'firmReference', null)) &&
                      featureService.hasFeature(FEATURES.LIMIT_INVOICE_DATE)
                    }
                    limitInvoiceDate={getLimitInvoiceManager(
                      get(props.listings, 'appConfig', []),
                    )}
                  />
                </div>
              ))}
            </>
          }
        />
      )}
    </Container>
  );
};

export default injectIntl(FormsADD);
